@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(157_767_874)
internal val Res.string.chatlist_tab_profile: StringResource by lazy {
      StringResource("string:chatlist_tab_profile", "chatlist_tab_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6697, 48),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4717, 40),
      ))
    }

@delegate:ResourceContentHash(1_387_381_412)
internal val Res.string.chatlist_tab_tasks: StringResource by lazy {
      StringResource("string:chatlist_tab_tasks", "chatlist_tab_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6746, 46),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4758, 34),
      ))
    }

@delegate:ResourceContentHash(-454_636_475)
internal val Res.string.chatlist_title: StringResource by lazy {
      StringResource("string:chatlist_title", "chatlist_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6793, 34),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4793, 30),
      ))
    }

@delegate:ResourceContentHash(394_178_744)
internal val Res.string.chatlist_typing_preview: StringResource by lazy {
      StringResource("string:chatlist_typing_preview", "chatlist_typing_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_chatlist.commonMain.cvr", 6828, 59),
        ResourceItem(setOf(), "${MD}values/strings_chatlist.commonMain.cvr", 4824, 43),
      ))
    }

@delegate:ResourceContentHash(1_801_578_708)
internal val Res.string.comments_close: StringResource by lazy {
      StringResource("string:comments_close", "comments_close", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_comments.commonMain.cvr", 10, 74),
        ResourceItem(setOf(), "${MD}values/strings_comments.commonMain.cvr", 10, 42),
      ))
    }

@delegate:ResourceContentHash(2_143_795_835)
internal val Res.string.comments_more_actions: StringResource by lazy {
      StringResource("string:comments_more_actions", "comments_more_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_comments.commonMain.cvr", 85, 89),
        ResourceItem(setOf(), "${MD}values/strings_comments.commonMain.cvr", 53, 69),
      ))
    }

@delegate:ResourceContentHash(1_708_622_061)
internal val Res.string.comments_title: StringResource by lazy {
      StringResource("string:comments_title", "comments_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_comments.commonMain.cvr", 175, 54),
        ResourceItem(setOf(), "${MD}values/strings_comments.commonMain.cvr", 123, 34),
      ))
    }

@delegate:ResourceContentHash(-1_053_985_393)
internal val Res.string.discover_browse_all_time: StringResource by lazy {
      StringResource("string:discover_browse_all_time", "discover_browse_all_time", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 10, 56),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 10, 44),
      ))
    }

@delegate:ResourceContentHash(277_057_698)
internal val Res.string.discover_browse_apply: StringResource by lazy {
      StringResource("string:discover_browse_apply", "discover_browse_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 67, 73),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 55, 49),
      ))
    }

@delegate:ResourceContentHash(1_948_966_498)
internal val Res.string.discover_browse_clear: StringResource by lazy {
      StringResource("string:discover_browse_clear", "discover_browse_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 141, 65),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 105, 45),
      ))
    }

@delegate:ResourceContentHash(-626_184_995)
internal val Res.string.discover_browse_filters: StringResource by lazy {
      StringResource("string:discover_browse_filters", "discover_browse_filters", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 207, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 151, 47),
      ))
    }

@delegate:ResourceContentHash(1_417_083_789)
internal val Res.string.discover_browse_month: StringResource by lazy {
      StringResource("string:discover_browse_month", "discover_browse_month", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 275, 45),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 199, 41),
      ))
    }

@delegate:ResourceContentHash(-1_677_904_439)
internal val Res.string.discover_browse_newest: StringResource by lazy {
      StringResource("string:discover_browse_newest", "discover_browse_newest", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 321, 46),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 241, 38),
      ))
    }

@delegate:ResourceContentHash(485_217_803)
internal val Res.string.discover_browse_no_results: StringResource by lazy {
      StringResource("string:discover_browse_no_results", "discover_browse_no_results", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 504, 74),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 376, 58),
      ))
    }

@delegate:ResourceContentHash(-1_934_503_072)
internal val Res.string.discover_browse_no_results_body: StringResource by lazy {
      StringResource("string:discover_browse_no_results_body", "discover_browse_no_results_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 368, 135),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 280, 95),
      ))
    }

@delegate:ResourceContentHash(-145_757_581)
internal val Res.string.discover_browse_period: StringResource by lazy {
      StringResource("string:discover_browse_period", "discover_browse_period", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 579, 46),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 435, 46),
      ))
    }

@delegate:ResourceContentHash(606_050_758)
internal val Res.string.discover_browse_popular: StringResource by lazy {
      StringResource("string:discover_browse_popular", "discover_browse_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 626, 59),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 482, 47),
      ))
    }

@delegate:ResourceContentHash(-820_175_322)
internal val Res.string.discover_browse_reset: StringResource by lazy {
      StringResource("string:discover_browse_reset", "discover_browse_reset", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 686, 73),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 530, 49),
      ))
    }

@delegate:ResourceContentHash(1_418_822_945)
internal val Res.string.discover_browse_search: StringResource by lazy {
      StringResource("string:discover_browse_search", "discover_browse_search", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 760, 94),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 580, 74),
      ))
    }

@delegate:ResourceContentHash(-2_034_844_051)
internal val Res.string.discover_browse_sending: StringResource by lazy {
      StringResource("string:discover_browse_sending", "discover_browse_sending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 855, 71),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 655, 51),
      ))
    }

@delegate:ResourceContentHash(154_007_152)
internal val Res.string.discover_browse_sort: StringResource by lazy {
      StringResource("string:discover_browse_sort", "discover_browse_sort", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 927, 56),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 707, 40),
      ))
    }

@delegate:ResourceContentHash(-1_339_312_399)
internal val Res.string.discover_browse_trending: StringResource by lazy {
      StringResource("string:discover_browse_trending", "discover_browse_trending", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 1214, 84),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 938, 56),
      ))
    }

@delegate:ResourceContentHash(301_099_888)
internal val Res.string.discover_browse_trending_active: StringResource by lazy {
      StringResource("string:discover_browse_trending_active", "discover_browse_trending_active", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 984, 135),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 748, 99),
      ))
    }

@delegate:ResourceContentHash(199_486_366)
internal val Res.string.discover_browse_trending_body: StringResource by lazy {
      StringResource("string:discover_browse_trending_body", "discover_browse_trending_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 1120, 93),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 848, 89),
      ))
    }

@delegate:ResourceContentHash(1_095_659_526)
internal val Res.string.discover_browse_unread: StringResource by lazy {
      StringResource("string:discover_browse_unread", "discover_browse_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 1299, 102),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 995, 58),
      ))
    }

@delegate:ResourceContentHash(-795_245_816)
internal val Res.string.discover_browse_week: StringResource by lazy {
      StringResource("string:discover_browse_week", "discover_browse_week", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-browse.commonMain.cvr", 1402, 44),
        ResourceItem(setOf(), "${MD}values/strings_discover-browse.commonMain.cvr", 1054, 36),
      ))
    }

@delegate:ResourceContentHash(807_033_366)
internal val Res.string.discover_comment_action: StringResource by lazy {
      StringResource("string:discover_comment_action", "discover_comment_action", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3006, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2300, 43),
      ))
    }

@delegate:ResourceContentHash(1_867_154_743)
internal val Res.string.discover_comments_openable: StringResource by lazy {
      StringResource("string:discover_comments_openable", "discover_comments_openable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3078, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2344, 54),
      ))
    }

@delegate:ResourceContentHash(-525_912_568)
internal val Res.string.discover_empty_body: StringResource by lazy {
      StringResource("string:discover_empty_body", "discover_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3153, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2399, 59),
      ))
    }

@delegate:ResourceContentHash(1_423_592_496)
internal val Res.string.discover_groups_activity: StringResource by lazy {
      StringResource("string:discover_groups_activity", "discover_groups_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4200, 60),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3628, 44),
      ))
    }

@delegate:ResourceContentHash(-1_618_676_535)
internal val Res.string.discover_groups_activity_answer: StringResource by lazy {
      StringResource("string:discover_groups_activity_answer", "discover_groups_activity_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3258, 111),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3030, 75),
      ))
    }

@delegate:ResourceContentHash(695_186_794)
internal val Res.string.discover_groups_activity_comment: StringResource by lazy {
      StringResource("string:discover_groups_activity_comment", "discover_groups_activity_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3370, 136),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3106, 76),
      ))
    }

@delegate:ResourceContentHash(441_880_602)
internal val Res.string.discover_groups_activity_empty_body: StringResource by lazy {
      StringResource("string:discover_groups_activity_empty_body", "discover_groups_activity_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3507, 187),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3183, 119),
      ))
    }

@delegate:ResourceContentHash(532_667_793)
internal val Res.string.discover_groups_activity_empty_title: StringResource by lazy {
      StringResource("string:discover_groups_activity_empty_title", "discover_groups_activity_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3695, 96),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3303, 68),
      ))
    }

@delegate:ResourceContentHash(56_349_066)
internal val Res.string.discover_groups_activity_load_failed: StringResource by lazy {
      StringResource("string:discover_groups_activity_load_failed", "discover_groups_activity_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3792, 124),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3372, 76),
      ))
    }

@delegate:ResourceContentHash(-768_222_906)
internal val Res.string.discover_groups_activity_mention_comment: StringResource by lazy {
      StringResource("string:discover_groups_activity_mention_comment", "discover_groups_activity_mention_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 3917, 144),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3449, 92),
      ))
    }

@delegate:ResourceContentHash(1_438_298_362)
internal val Res.string.discover_groups_activity_mention_post: StringResource by lazy {
      StringResource("string:discover_groups_activity_mention_post", "discover_groups_activity_mention_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4062, 137),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3542, 85),
      ))
    }

@delegate:ResourceContentHash(-1_774_990_083)
internal val Res.string.discover_groups_add_comment: StringResource by lazy {
      StringResource("string:discover_groups_add_comment", "discover_groups_add_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4261, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3673, 55),
      ))
    }

@delegate:ResourceContentHash(1_511_336_992)
internal val Res.string.discover_groups_add_outcome: StringResource by lazy {
      StringResource("string:discover_groups_add_outcome", "discover_groups_add_outcome", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4329, 83),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3729, 51),
      ))
    }

@delegate:ResourceContentHash(703_995_795)
internal val Res.string.discover_groups_answer_action_failed: StringResource by lazy {
      StringResource("string:discover_groups_answer_action_failed", "discover_groups_answer_action_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4413, 128),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3781, 88),
      ))
    }

@delegate:ResourceContentHash(-190_044_963)
internal val Res.string.discover_groups_back: StringResource by lazy {
      StringResource("string:discover_groups_back", "discover_groups_back", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4542, 44),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3870, 36),
      ))
    }

@delegate:ResourceContentHash(1_515_850_964)
internal val Res.string.discover_groups_ban: StringResource by lazy {
      StringResource("string:discover_groups_ban", "discover_groups_ban", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5815, 63),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4611, 31),
      ))
    }

@delegate:ResourceContentHash(-1_052_297_433)
internal val Res.string.discover_groups_ban_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_ban_confirm_body", "discover_groups_ban_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4587, 388),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 3907, 236),
      ))
    }

@delegate:ResourceContentHash(32_187_086)
internal val Res.string.discover_groups_ban_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_ban_confirm_title", "discover_groups_ban_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 4976, 109),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4144, 53),
      ))
    }

@delegate:ResourceContentHash(-120_108_761)
internal val Res.string.discover_groups_ban_detail: StringResource by lazy {
      StringResource("string:discover_groups_ban_detail", "discover_groups_ban_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5216, 118),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4268, 54),
      ))
    }

@delegate:ResourceContentHash(2_017_333_522)
internal val Res.string.discover_groups_ban_detail_on: StringResource by lazy {
      StringResource("string:discover_groups_ban_detail_on", "discover_groups_ban_detail_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5086, 129),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4198, 69),
      ))
    }

@delegate:ResourceContentHash(759_847_768)
internal val Res.string.discover_groups_ban_from_group: StringResource by lazy {
      StringResource("string:discover_groups_ban_from_group", "discover_groups_ban_from_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5335, 94),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4323, 58),
      ))
    }

@delegate:ResourceContentHash(1_728_104_469)
internal val Res.string.discover_groups_bans_empty_body: StringResource by lazy {
      StringResource("string:discover_groups_bans_empty_body", "discover_groups_bans_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5430, 291),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4382, 163),
      ))
    }

@delegate:ResourceContentHash(909_622_544)
internal val Res.string.discover_groups_bans_empty_title: StringResource by lazy {
      StringResource("string:discover_groups_bans_empty_title", "discover_groups_bans_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5722, 92),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4546, 64),
      ))
    }

@delegate:ResourceContentHash(1_441_718_749)
internal val Res.string.discover_groups_best_answer: StringResource by lazy {
      StringResource("string:discover_groups_best_answer", "discover_groups_best_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5879, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4643, 51),
      ))
    }

@delegate:ResourceContentHash(-1_038_293_232)
internal val Res.string.discover_groups_bookmark_failed: StringResource by lazy {
      StringResource("string:discover_groups_bookmark_failed", "discover_groups_bookmark_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 5947, 139),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4695, 79),
      ))
    }

@delegate:ResourceContentHash(-2_032_690_309)
internal val Res.string.discover_groups_cached_freshness: StringResource by lazy {
      StringResource("string:discover_groups_cached_freshness", "discover_groups_cached_freshness", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6087, 96),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4775, 64),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.discover_groups_cancel: StringResource by lazy {
      StringResource("string:discover_groups_cancel", "discover_groups_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6184, 46),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4840, 38),
      ))
    }

@delegate:ResourceContentHash(-395_169_559)
internal val Res.string.discover_groups_choose_destination: StringResource by lazy {
      StringResource("string:discover_groups_choose_destination", "discover_groups_choose_destination", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6231, 86),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4879, 74),
      ))
    }

@delegate:ResourceContentHash(-1_199_341_178)
internal val Res.string.discover_groups_choose_post_type: StringResource by lazy {
      StringResource("string:discover_groups_choose_post_type", "discover_groups_choose_post_type", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6318, 76),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 4954, 68),
      ))
    }

@delegate:ResourceContentHash(-1_589_994_288)
internal val Res.string.discover_groups_clear_best_answer: StringResource by lazy {
      StringResource("string:discover_groups_clear_best_answer", "discover_groups_clear_best_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6395, 93),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5023, 61),
      ))
    }

@delegate:ResourceContentHash(1_356_809_547)
internal val Res.string.discover_groups_comment_deleted: StringResource by lazy {
      StringResource("string:discover_groups_comment_deleted", "discover_groups_comment_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6489, 99),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5085, 79),
      ))
    }

@delegate:ResourceContentHash(-1_565_498_541)
internal val Res.string.discover_groups_comment_post_failed: StringResource by lazy {
      StringResource("string:discover_groups_comment_post_failed", "discover_groups_comment_post_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6589, 135),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5165, 83),
      ))
    }

@delegate:ResourceContentHash(-1_653_605_278)
internal val Res.string.discover_groups_comments_more_failed: StringResource by lazy {
      StringResource("string:discover_groups_comments_more_failed", "discover_groups_comments_more_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6725, 136),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5249, 84),
      ))
    }

@delegate:ResourceContentHash(-577_731_039)
internal val Res.string.discover_groups_composer_placeholder_global: StringResource by lazy {
      StringResource("string:discover_groups_composer_placeholder_global", "discover_groups_composer_placeholder_global", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6862, 135),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5334, 107),
      ))
    }

@delegate:ResourceContentHash(-1_019_072_858)
internal val Res.string.discover_groups_composer_placeholder_group: StringResource by lazy {
      StringResource("string:discover_groups_composer_placeholder_group", "discover_groups_composer_placeholder_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 6998, 158),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5442, 106),
      ))
    }

@delegate:ResourceContentHash(-131_539_416)
internal val Res.string.discover_groups_copy_link: StringResource by lazy {
      StringResource("string:discover_groups_copy_link", "discover_groups_copy_link", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7157, 81),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5549, 45),
      ))
    }

@delegate:ResourceContentHash(1_051_433_607)
internal val Res.string.discover_groups_create_group: StringResource by lazy {
      StringResource("string:discover_groups_create_group", "discover_groups_create_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7239, 72),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5595, 52),
      ))
    }

@delegate:ResourceContentHash(-1_218_911_765)
internal val Res.string.discover_groups_create_plan_from_idea: StringResource by lazy {
      StringResource("string:discover_groups_create_plan_from_idea", "discover_groups_create_plan_from_idea", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7312, 109),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5648, 81),
      ))
    }

@delegate:ResourceContentHash(2_122_233_061)
internal val Res.string.discover_groups_delete: StringResource by lazy {
      StringResource("string:discover_groups_delete", "discover_groups_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9119, 50),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6895, 38),
      ))
    }

@delegate:ResourceContentHash(-1_392_294_575)
internal val Res.string.discover_groups_delete_comment_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_delete_comment_confirm_body", "discover_groups_delete_comment_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7422, 239),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5730, 159),
      ))
    }

@delegate:ResourceContentHash(-584_913_422)
internal val Res.string.discover_groups_delete_comment_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_delete_comment_confirm_title", "discover_groups_delete_comment_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7662, 104),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5890, 80),
      ))
    }

@delegate:ResourceContentHash(-2_113_754_186)
internal val Res.string.discover_groups_delete_comment_failed: StringResource by lazy {
      StringResource("string:discover_groups_delete_comment_failed", "discover_groups_delete_comment_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7767, 125),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 5971, 85),
      ))
    }

@delegate:ResourceContentHash(549_280_287)
internal val Res.string.discover_groups_delete_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_delete_confirm_body", "discover_groups_delete_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 7893, 251),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6057, 163),
      ))
    }

@delegate:ResourceContentHash(1_811_584_987)
internal val Res.string.discover_groups_delete_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_delete_confirm_title", "discover_groups_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8145, 88),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6221, 60),
      ))
    }

@delegate:ResourceContentHash(536_707_232)
internal val Res.string.discover_groups_delete_group: StringResource by lazy {
      StringResource("string:discover_groups_delete_group", "discover_groups_delete_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8354, 72),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6366, 52),
      ))
    }

@delegate:ResourceContentHash(-498_303_026)
internal val Res.string.discover_groups_delete_group_failed: StringResource by lazy {
      StringResource("string:discover_groups_delete_group_failed", "discover_groups_delete_group_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8234, 119),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6282, 83),
      ))
    }

@delegate:ResourceContentHash(1_203_182_727)
internal val Res.string.discover_groups_delete_owner_only: StringResource by lazy {
      StringResource("string:discover_groups_delete_owner_only", "discover_groups_delete_owner_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8427, 133),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6419, 93),
      ))
    }

@delegate:ResourceContentHash(-196_975_531)
internal val Res.string.discover_groups_delete_post: StringResource by lazy {
      StringResource("string:discover_groups_delete_post", "discover_groups_delete_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9047, 71),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6843, 51),
      ))
    }

@delegate:ResourceContentHash(655_670_691)
internal val Res.string.discover_groups_delete_post_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_delete_post_confirm_body", "discover_groups_delete_post_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8561, 268),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6513, 176),
      ))
    }

@delegate:ResourceContentHash(521_112_092)
internal val Res.string.discover_groups_delete_post_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_delete_post_confirm_title", "discover_groups_delete_post_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8830, 97),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6690, 73),
      ))
    }

@delegate:ResourceContentHash(-100_422_080)
internal val Res.string.discover_groups_delete_post_failed: StringResource by lazy {
      StringResource("string:discover_groups_delete_post_failed", "discover_groups_delete_post_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 8928, 118),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6764, 78),
      ))
    }

@delegate:ResourceContentHash(-606_853_968)
internal val Res.string.discover_groups_derived_posts: StringResource by lazy {
      StringResource("string:discover_groups_derived_posts", "discover_groups_derived_posts", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9170, 89),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6934, 61),
      ))
    }

@delegate:ResourceContentHash(1_885_876_466)
internal val Res.string.discover_groups_description_counter: StringResource by lazy {
      StringResource("string:discover_groups_description_counter", "discover_groups_description_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9260, 95),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 6996, 71),
      ))
    }

@delegate:ResourceContentHash(-1_430_115_542)
internal val Res.string.discover_groups_description_label: StringResource by lazy {
      StringResource("string:discover_groups_description_label", "discover_groups_description_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9356, 65),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7068, 57),
      ))
    }

@delegate:ResourceContentHash(1_373_316_375)
internal val Res.string.discover_groups_description_placeholder: StringResource by lazy {
      StringResource("string:discover_groups_description_placeholder", "discover_groups_description_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9422, 95),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7126, 79),
      ))
    }

@delegate:ResourceContentHash(1_023_003_491)
internal val Res.string.discover_groups_destination_global: StringResource by lazy {
      StringResource("string:discover_groups_destination_global", "discover_groups_destination_global", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9518, 70),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7206, 50),
      ))
    }

@delegate:ResourceContentHash(1_763_030_467)
internal val Res.string.discover_groups_destination_this_group: StringResource by lazy {
      StringResource("string:discover_groups_destination_this_group", "discover_groups_destination_this_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9589, 74),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7257, 62),
      ))
    }

@delegate:ResourceContentHash(424_367_203)
internal val Res.string.discover_groups_discard: StringResource by lazy {
      StringResource("string:discover_groups_discard", "discover_groups_discard", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9977, 59),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7541, 43),
      ))
    }

@delegate:ResourceContentHash(953_734_884)
internal val Res.string.discover_groups_discard_body: StringResource by lazy {
      StringResource("string:discover_groups_discard_body", "discover_groups_discard_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9664, 116),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7320, 92),
      ))
    }

@delegate:ResourceContentHash(1_678_868_713)
internal val Res.string.discover_groups_discard_this_post: StringResource by lazy {
      StringResource("string:discover_groups_discard_this_post", "discover_groups_discard_this_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9781, 93),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7413, 65),
      ))
    }

@delegate:ResourceContentHash(-770_258_959)
internal val Res.string.discover_groups_discard_title: StringResource by lazy {
      StringResource("string:discover_groups_discard_title", "discover_groups_discard_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 9875, 101),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7479, 61),
      ))
    }

@delegate:ResourceContentHash(650_839_504)
internal val Res.string.discover_groups_discover_title: StringResource by lazy {
      StringResource("string:discover_groups_discover_title", "discover_groups_discover_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10037, 54),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7585, 50),
      ))
    }

@delegate:ResourceContentHash(58_828_203)
internal val Res.string.discover_groups_edit: StringResource by lazy {
      StringResource("string:discover_groups_edit", "discover_groups_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10342, 52),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7818, 36),
      ))
    }

@delegate:ResourceContentHash(1_138_820_044)
internal val Res.string.discover_groups_edit_post: StringResource by lazy {
      StringResource("string:discover_groups_edit_post", "discover_groups_edit_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10092, 73),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7636, 45),
      ))
    }

@delegate:ResourceContentHash(-1_004_001_492)
internal val Res.string.discover_groups_edit_window_expired: StringResource by lazy {
      StringResource("string:discover_groups_edit_window_expired", "discover_groups_edit_window_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10166, 175),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7682, 135),
      ))
    }

@delegate:ResourceContentHash(1_556_402_460)
internal val Res.string.discover_groups_empty_title: StringResource by lazy {
      StringResource("string:discover_groups_empty_title", "discover_groups_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10395, 79),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7855, 55),
      ))
    }

@delegate:ResourceContentHash(734_352_636)
internal val Res.string.discover_groups_feed_load_failed: StringResource by lazy {
      StringResource("string:discover_groups_feed_load_failed", "discover_groups_feed_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10475, 108),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7911, 72),
      ))
    }

@delegate:ResourceContentHash(657_683_512)
internal val Res.string.discover_groups_feed_members_only: StringResource by lazy {
      StringResource("string:discover_groups_feed_members_only", "discover_groups_feed_members_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10584, 157),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 7984, 113),
      ))
    }

@delegate:ResourceContentHash(1_970_135_042)
internal val Res.string.discover_groups_feed_more_failed: StringResource by lazy {
      StringResource("string:discover_groups_feed_more_failed", "discover_groups_feed_more_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10742, 120),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8098, 76),
      ))
    }

@delegate:ResourceContentHash(-463_483_192)
internal val Res.string.discover_groups_feed_unavailable: StringResource by lazy {
      StringResource("string:discover_groups_feed_unavailable", "discover_groups_feed_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10863, 112),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8175, 84),
      ))
    }

@delegate:ResourceContentHash(439_539_190)
internal val Res.string.discover_groups_filter_all: StringResource by lazy {
      StringResource("string:discover_groups_filter_all", "discover_groups_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 10976, 42),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8260, 38),
      ))
    }

@delegate:ResourceContentHash(1_477_117_650)
internal val Res.string.discover_groups_group_freshness_description: StringResource by lazy {
      StringResource("string:discover_groups_group_freshness_description", "discover_groups_group_freshness_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11019, 251),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8299, 179),
      ))
    }

@delegate:ResourceContentHash(1_482_782_673)
internal val Res.string.discover_groups_group_gone: StringResource by lazy {
      StringResource("string:discover_groups_group_gone", "discover_groups_group_gone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11271, 106),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8479, 82),
      ))
    }

@delegate:ResourceContentHash(319_660_063)
internal val Res.string.discover_groups_group_load_failed: StringResource by lazy {
      StringResource("string:discover_groups_group_load_failed", "discover_groups_group_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11378, 121),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8562, 77),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("chatlist_tab_profile", Res.string.chatlist_tab_profile)
  map.put("chatlist_tab_tasks", Res.string.chatlist_tab_tasks)
  map.put("chatlist_title", Res.string.chatlist_title)
  map.put("chatlist_typing_preview", Res.string.chatlist_typing_preview)
  map.put("comments_close", Res.string.comments_close)
  map.put("comments_more_actions", Res.string.comments_more_actions)
  map.put("comments_title", Res.string.comments_title)
  map.put("discover_browse_all_time", Res.string.discover_browse_all_time)
  map.put("discover_browse_apply", Res.string.discover_browse_apply)
  map.put("discover_browse_clear", Res.string.discover_browse_clear)
  map.put("discover_browse_filters", Res.string.discover_browse_filters)
  map.put("discover_browse_month", Res.string.discover_browse_month)
  map.put("discover_browse_newest", Res.string.discover_browse_newest)
  map.put("discover_browse_no_results", Res.string.discover_browse_no_results)
  map.put("discover_browse_no_results_body", Res.string.discover_browse_no_results_body)
  map.put("discover_browse_period", Res.string.discover_browse_period)
  map.put("discover_browse_popular", Res.string.discover_browse_popular)
  map.put("discover_browse_reset", Res.string.discover_browse_reset)
  map.put("discover_browse_search", Res.string.discover_browse_search)
  map.put("discover_browse_sending", Res.string.discover_browse_sending)
  map.put("discover_browse_sort", Res.string.discover_browse_sort)
  map.put("discover_browse_trending", Res.string.discover_browse_trending)
  map.put("discover_browse_trending_active", Res.string.discover_browse_trending_active)
  map.put("discover_browse_trending_body", Res.string.discover_browse_trending_body)
  map.put("discover_browse_unread", Res.string.discover_browse_unread)
  map.put("discover_browse_week", Res.string.discover_browse_week)
  map.put("discover_comment_action", Res.string.discover_comment_action)
  map.put("discover_comments_openable", Res.string.discover_comments_openable)
  map.put("discover_empty_body", Res.string.discover_empty_body)
  map.put("discover_groups_activity", Res.string.discover_groups_activity)
  map.put("discover_groups_activity_answer", Res.string.discover_groups_activity_answer)
  map.put("discover_groups_activity_comment", Res.string.discover_groups_activity_comment)
  map.put("discover_groups_activity_empty_body", Res.string.discover_groups_activity_empty_body)
  map.put("discover_groups_activity_empty_title", Res.string.discover_groups_activity_empty_title)
  map.put("discover_groups_activity_load_failed", Res.string.discover_groups_activity_load_failed)
  map.put("discover_groups_activity_mention_comment", Res.string.discover_groups_activity_mention_comment)
  map.put("discover_groups_activity_mention_post", Res.string.discover_groups_activity_mention_post)
  map.put("discover_groups_add_comment", Res.string.discover_groups_add_comment)
  map.put("discover_groups_add_outcome", Res.string.discover_groups_add_outcome)
  map.put("discover_groups_answer_action_failed", Res.string.discover_groups_answer_action_failed)
  map.put("discover_groups_back", Res.string.discover_groups_back)
  map.put("discover_groups_ban", Res.string.discover_groups_ban)
  map.put("discover_groups_ban_confirm_body", Res.string.discover_groups_ban_confirm_body)
  map.put("discover_groups_ban_confirm_title", Res.string.discover_groups_ban_confirm_title)
  map.put("discover_groups_ban_detail", Res.string.discover_groups_ban_detail)
  map.put("discover_groups_ban_detail_on", Res.string.discover_groups_ban_detail_on)
  map.put("discover_groups_ban_from_group", Res.string.discover_groups_ban_from_group)
  map.put("discover_groups_bans_empty_body", Res.string.discover_groups_bans_empty_body)
  map.put("discover_groups_bans_empty_title", Res.string.discover_groups_bans_empty_title)
  map.put("discover_groups_best_answer", Res.string.discover_groups_best_answer)
  map.put("discover_groups_bookmark_failed", Res.string.discover_groups_bookmark_failed)
  map.put("discover_groups_cached_freshness", Res.string.discover_groups_cached_freshness)
  map.put("discover_groups_cancel", Res.string.discover_groups_cancel)
  map.put("discover_groups_choose_destination", Res.string.discover_groups_choose_destination)
  map.put("discover_groups_choose_post_type", Res.string.discover_groups_choose_post_type)
  map.put("discover_groups_clear_best_answer", Res.string.discover_groups_clear_best_answer)
  map.put("discover_groups_comment_deleted", Res.string.discover_groups_comment_deleted)
  map.put("discover_groups_comment_post_failed", Res.string.discover_groups_comment_post_failed)
  map.put("discover_groups_comments_more_failed", Res.string.discover_groups_comments_more_failed)
  map.put("discover_groups_composer_placeholder_global", Res.string.discover_groups_composer_placeholder_global)
  map.put("discover_groups_composer_placeholder_group", Res.string.discover_groups_composer_placeholder_group)
  map.put("discover_groups_copy_link", Res.string.discover_groups_copy_link)
  map.put("discover_groups_create_group", Res.string.discover_groups_create_group)
  map.put("discover_groups_create_plan_from_idea", Res.string.discover_groups_create_plan_from_idea)
  map.put("discover_groups_delete", Res.string.discover_groups_delete)
  map.put("discover_groups_delete_comment_confirm_body", Res.string.discover_groups_delete_comment_confirm_body)
  map.put("discover_groups_delete_comment_confirm_title", Res.string.discover_groups_delete_comment_confirm_title)
  map.put("discover_groups_delete_comment_failed", Res.string.discover_groups_delete_comment_failed)
  map.put("discover_groups_delete_confirm_body", Res.string.discover_groups_delete_confirm_body)
  map.put("discover_groups_delete_confirm_title", Res.string.discover_groups_delete_confirm_title)
  map.put("discover_groups_delete_group", Res.string.discover_groups_delete_group)
  map.put("discover_groups_delete_group_failed", Res.string.discover_groups_delete_group_failed)
  map.put("discover_groups_delete_owner_only", Res.string.discover_groups_delete_owner_only)
  map.put("discover_groups_delete_post", Res.string.discover_groups_delete_post)
  map.put("discover_groups_delete_post_confirm_body", Res.string.discover_groups_delete_post_confirm_body)
  map.put("discover_groups_delete_post_confirm_title", Res.string.discover_groups_delete_post_confirm_title)
  map.put("discover_groups_delete_post_failed", Res.string.discover_groups_delete_post_failed)
  map.put("discover_groups_derived_posts", Res.string.discover_groups_derived_posts)
  map.put("discover_groups_description_counter", Res.string.discover_groups_description_counter)
  map.put("discover_groups_description_label", Res.string.discover_groups_description_label)
  map.put("discover_groups_description_placeholder", Res.string.discover_groups_description_placeholder)
  map.put("discover_groups_destination_global", Res.string.discover_groups_destination_global)
  map.put("discover_groups_destination_this_group", Res.string.discover_groups_destination_this_group)
  map.put("discover_groups_discard", Res.string.discover_groups_discard)
  map.put("discover_groups_discard_body", Res.string.discover_groups_discard_body)
  map.put("discover_groups_discard_this_post", Res.string.discover_groups_discard_this_post)
  map.put("discover_groups_discard_title", Res.string.discover_groups_discard_title)
  map.put("discover_groups_discover_title", Res.string.discover_groups_discover_title)
  map.put("discover_groups_edit", Res.string.discover_groups_edit)
  map.put("discover_groups_edit_post", Res.string.discover_groups_edit_post)
  map.put("discover_groups_edit_window_expired", Res.string.discover_groups_edit_window_expired)
  map.put("discover_groups_empty_title", Res.string.discover_groups_empty_title)
  map.put("discover_groups_feed_load_failed", Res.string.discover_groups_feed_load_failed)
  map.put("discover_groups_feed_members_only", Res.string.discover_groups_feed_members_only)
  map.put("discover_groups_feed_more_failed", Res.string.discover_groups_feed_more_failed)
  map.put("discover_groups_feed_unavailable", Res.string.discover_groups_feed_unavailable)
  map.put("discover_groups_filter_all", Res.string.discover_groups_filter_all)
  map.put("discover_groups_group_freshness_description", Res.string.discover_groups_group_freshness_description)
  map.put("discover_groups_group_gone", Res.string.discover_groups_group_gone)
  map.put("discover_groups_group_load_failed", Res.string.discover_groups_group_load_failed)
}
